export default __webpack_public_path__ + "static/media/11-BB-(4-3).8894ed9c.jpg";